import {
  ABCampaign,
  ABCampaignGoalMetric,
  ABCampaignSegments,
  ABCampaignStatus,
  ABCampaignTargetDevice
} from '@/common/model/recommend/abCampaign'

export const AbCampaignApiPath = {
  LIST_AB_CAMPAIGNS: '/api/sites/{site_id}/ab-campaigns', // GET List Campaigns
  CREATE_AB_CAMPAIGNS: '/api/sites/{site_id}/ab-campaigns', // POST Create Campaign
  GET_AB_CAMPAIGN: '/api/sites/{site_id}/ab-campaigns/{campaign_id}', // GET Get Campaign
  UPDATE_AB_CAMPAIGN: '/api/sites/{site_id}/ab-campaigns/{campaign_id}', // PUT Update Campaign
  DELETE_AB_CAMPAIGN: '/api/sites/{site_id}/ab-campaigns/{campaign_id}', // DELETE Delete Campaign
  START_AB_CAMPAIGN: '/api/sites/{site_id}/ab-campaigns/{campaign_id}/start', // POST Start Campaign
  COMPLETE_AB_CAMPAIGN: '/api/sites/{site_id}/ab-campaigns/{campaign_id}/complete', // POST Complete Campaign
  GET_AB_CAMPAIGN_STATS: '/api/sites/{site_id}/ab-campaigns/{campaign_id}/stats', // GET Get Campaign Stats
  GET_AB_CAMPAIGN_DAILY_SERIES: '/api/sites/{site_id}/ab-campaigns/{campaign_id}/daily-series' // GET Get Daily Series
}

export type AbCampaignApiPath = (typeof AbCampaignApiPath)[keyof typeof AbCampaignApiPath]

export interface ListAbCampaignsVars {
  site_id: number
}

export interface CreateAbCampaignsVars {
  site_id: number
  widget_id: number
  goal_metric?: ABCampaignGoalMetric
  target_devices?: ABCampaignTargetDevice[] | null
  target_segments?: ABCampaignSegments[] | null
  min_sample_per_variant?: number
  confidence_level?: number
}

export interface GetAbCampaignVars {
  site_id: number
  campaign_id: number
}

export interface UpdateAbCampaignVars {
  site_id: number
  campaign_id: number
  goal_metric?: ABCampaignGoalMetric | null
  target_devices?: ABCampaignTargetDevice[] | null
  target_segments?: ABCampaignSegments[] | null
  min_sample_per_variant?: number | null
  confidence_level?: number | null
}

export interface DeleteAbCampaignVars {
  site_id: number
  campaign_id: number
}

export interface StartAbCampaignVars {
  site_id: number
  campaign_id: number
}

export interface CompleteAbCampaignVars {
  site_id: number
  campaign_id: number
}

export interface GetAbCampaignStatsVars {
  site_id: number
  campaign_id: number
}

export interface GetAbCampaignDailySeriesVars {
  site_id: number
  campaign_id: number
}

export type ListAbCampaignsResponse = ABCampaign[]
export type CreateAbCampaignsResponse = ABCampaign
export type GetAbCampaignResponse = ABCampaign
export type UpdateAbCampaignResponse = ABCampaign
export interface DeleteAbCampaignResponse {
  deleted: boolean
}
export type StartAbCampaignResponse = ABCampaign
export type CompleteAbCampaignResponse = ABCampaign

export interface CampaignVariantStat {
  group: string
  impressions: number
  clicks: number
  conversions: number
  revenue: number
  rate: number
}

export interface CampaignSignificance {
  z_score: number
  p_value: number
  best_variant: string | null
  lift_pct: number
  is_significant: boolean
}

export interface GetAbCampaignStatsResponse {
  campaign_id: number
  widget_name: string
  goal_metric: ABCampaignGoalMetric
  status: ABCampaignStatus
  variants: CampaignVariantStat[]
  sample_sufficient: boolean
  significance: CampaignSignificance | null
  recommended_sample?: number
  is_significant?: boolean
  winner_variant?: string | null
  recommended_sample_size?: number
}

export interface GetAbCampaignDailySeriesResponse {
  series: {
    date: string
    variants: Record<
      string,
      {
        impressions: number
        clicks?: number
        conversions?: number
        revenue?: number
        cumulative_rate: number
      }
    >
  }[]
}
